module.exports = __webpack_public_path__ + "static/media/upload.d4ad75a5.png";